import type {
  StockItem,
  StockItemDetails,
} from '../../common/types/StockItemTypes';

export const normalizeStockItems = (items: unknown[]): StockItemDetails[] => {
  if (!Array.isArray(items)) {
    return [];
  }
  return items
    .map((item: any) => {
      if (
        item &&
        typeof item === 'object' &&
        'id' in item &&
        'title' in item &&
        !item.stockItem
      ) {
        return { stockItem: item as StockItem };
      }
      if (item && typeof item === 'object' && item.stockItem) {
        return item as { stockItem: StockItem };
      }
      if (item && typeof item === 'object' && 'id' in item) {
        console.warn(
          'Unexpected item structure in normalizeStockItems, wrapping directly:',
          item
        );
        return { stockItem: item as StockItem };
      }
      return null;
    })
    .filter((item) => item !== null) as StockItemDetails[];
};
